import React, { useEffect, useState } from 'react';
// import { reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { jsonEditorStyles } from '../jsonEditorStyles';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import jsonComponentsConfig from '../../../constants/jsonComponents';
import useComponentUIHook from './useComponentUIHook';
import { SelectComponent, TextComponent } from '../../uiComponents';
import { OptionProps } from '../../../view-models';
import SessionManagement from './sessionManagement';
import { selectedLinks, getInitComponent } from '../utils';
import { cloneDeep } from 'lodash';
import { getFlowchartNodesEdges, setNodeData, getCurrentTabData, getNodeData } from '../../../store';
import { useSelector, useDispatch } from 'react-redux';
import { init_GoogleComponent, init_UserInputPageComponent } from '../init_components';
import cn from 'clsx';
import Box from '@mui/material/Box';
import { SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import settings from '../../../constants/jsonEditorUISettings';
import TemplatizedFieldComponent, { getTemplatizedValue, TemplatizedValue } from './templatizedFieldComponent';
import { sessionFieldsAreValid } from './sessionManagement';

const styles1 = makeStyles((theme: Theme) =>
  createStyles({
    addedComponent: {
      backgroundColor: '#1976d2 !important',
      color: 'white !important',
    },
  }),
);

const components: any[] = [
  { displayName: 'AAD Read', componentType: 'aadRead', disabled: false },
  { displayName: 'AAD Update', componentType: 'aadUpdate', disabled: false },
  { displayName: 'AAD Create', componentType: 'aadCreate', disabled: false },
  { displayName: 'REST API', componentType: 'restAPI', disabled: false },
  { displayName: 'App Insights', componentType: 'appInsights', disabled: false },
  { displayName: 'User Input Page', componentType: 'userInputPage', disabled: false },
  { displayName: 'MFA', componentType: 'mfa', disabled: false },
  { displayName: 'Token Issuer', componentType: 'tokenIssuer', disabled: false },
  { displayName: 'WebAuthn Registration', componentType: 'webAuthnRegistration', disabled: false },
  { displayName: 'WebAuthn Authentication', componentType: 'webAuthnAuthentication', disabled: false },
  { displayName: 'WebAuthn Availability', componentType: 'webAuthnAvailability', disabled: false },
  { displayName: 'WebAuthn Credentials Exist', componentType: 'webAuthnCredentialsExist', disabled: false },
  { displayName: 'OIDC IdP Authentication', componentType: 'oidcIdP', disabled: false},
  { displayName: 'SAML IdP Authentication', componentType: 'samlIdP', disabled: false},
];
interface componentProps {
  componentData: any;
  closeGritComponent: any;
  openSubmitActionFC: any;
  setUnsavedChanges: any;
}
const GenerateSignInUI = ({
  componentData,
  closeGritComponent,
  openSubmitActionFC,
  setUnsavedChanges,
}: componentProps) => {
  const { modifiedData, setModifiedData, checkIfSameIgnoringSubFlows, originalData, allClaims, onDeleteSubFlow, modifiedTemplatizations, setModifiedTemplatizations } =
    useComponentUIHook(componentData);
  const [disableSubmit, setDisableSubmit] = useState<boolean>(false);
  const [allAddComponents, setAllAddComponents] = useState<any[]>([]);
  const [newNodeData, setNewNodeData] = useState<any>({});
  const [addComponent, setAddComponent] = useState<string>('');
  const [addComponentName, setAddComponentName] = useState<string>('');
  const configData = jsonComponentsConfig.signIn.data;
  const flowchartNodesEdges = useSelector(getFlowchartNodesEdges);
  const classes = jsonEditorStyles();
  const classes1 = styles1();
  const dispatch = useDispatch();
  const currentFlowChartData = useSelector(getCurrentTabData);
  const allNodeData = useSelector(getNodeData);

  const getNewNodePositions = (curPos: any, siblingAvailable: boolean, incY: number, nop: number) => {
    const res: any = [];
    if (siblingAvailable) for (let i = 1; i <= nop; i++) res.push({ x: curPos['x'] + i * 350, y: curPos['y'] });
    else for (let i = 0; i < nop; i++) res.push({ x: curPos['x'] + i * 350, y: curPos['y'] + incY });
    return res;
  };
  const closeComponent = (data: any, addFormSubmitAction: boolean = false, subFlowType?: string) => {
    const index = flowchartNodesEdges.nodes.findIndex((node: any) => node['id'] === data.id);
    const originalLinks = selectedLinks(originalData['links']);
    const _selectedLinks = selectedLinks(data['links']);
    const deletedLinks: string[] = originalLinks.filter((value: string) => !_selectedLinks.includes(value));

    const originalNodeLinks = originalData.hasOwnProperty('nodeLinks') ? originalData['nodeLinks'] : [];
    const _selectedNodeLinks = data['nodeLinks'] || [];
    const deletedNodeLinks: string[] = originalNodeLinks.filter((value: string) => !_selectedNodeLinks.includes(value));
    let refPosition: any = cloneDeep(flowchartNodesEdges.nodes[index]['position']);
    let siblingAvailable: boolean = false;

    let closeData = cloneDeep(data);
    closeData['closeActions'] = {
      addNodes: [],
      delNodes: [],
      posArray: [],
    };

    let addedLinks: string[] = [];
    _selectedLinks.forEach((curLink: string) => {
      let _i = flowchartNodesEdges.nodes.findIndex((node: any) => node['linkType'] === curLink);
      if (_i >= 0) {
        // element available
        siblingAvailable = true;
        if (refPosition['x'] < flowchartNodesEdges.nodes[_i]['position']['x']) {
          refPosition['x'] = flowchartNodesEdges.nodes[_i]['position']['x'];
        }
        if (refPosition['y'] < flowchartNodesEdges.nodes[_i]['position']['y']) {
          refPosition['y'] = flowchartNodesEdges.nodes[_i]['position']['y'];
        }
      } else {
        addedLinks.push(curLink);
      }
    });
    if (deletedLinks.length > 0 || deletedNodeLinks.length > 0) {
      deletedLinks.concat(deletedNodeLinks).forEach((link: string) => {
        const _n = flowchartNodesEdges.edges.filter(
          (edge: any) => edge['source'].startsWith('signIn') && edge['target'].startsWith(link),
        );
        _n.length > 0 && closeData['closeActions']['delNodes'].push(_n[0]['target']);
      });
    }
    if (addedLinks.length > 0 || allAddComponents.length > 0) {
      const posArray = getNewNodePositions(
        refPosition,
        siblingAvailable,
        300,
        addedLinks.length + allAddComponents.length,
      );
      closeData['closeActions']['posArray'] = posArray;

      addedLinks.forEach((link: string, ind: number) => {
        let newNode: any;
        if (link === 'google') {
          const componentConfigData = jsonComponentsConfig[link];
          let initComponent: any = init_GoogleComponent();
          dispatch(
            setNodeData({
              [initComponent['id']]: { ...initComponent, parentNodeId: data?.id, linkId: true, linkType: link, flowchart: modifiedData['flowchart'] },
            }),
          );

          newNode = {
            id: initComponent['id'],
            parentNodeId: data?.id,
            type: componentConfigData['nodeType'],
            componentType: 'google',
            linkId: true,
            linkType: link,
            position: {},
            data: { label: jsonComponentsConfig[link]['label'] },
          };
        } else {
          const componentConfigData = jsonComponentsConfig['userInputPage'];
          let initComponent: any = init_UserInputPageComponent(link);
          dispatch(
            setNodeData({
              [initComponent['id']]: { ...initComponent, parentNodeId: data?.id, linkId: true, linkType: link, flowchart: modifiedData['flowchart'] },
            }),
          );

          newNode = {
            id: initComponent['id'],
            parentNodeId: data?.id,
            type: componentConfigData['nodeType'],
            componentType: 'userInputPage',
            linkId: true,
            linkType: link,
            position: {},
            data: { label: link },
          };
        }

        closeData['closeActions']['addNodes'].push(newNode);
      });
      allAddComponents.forEach((component: any, ind: number) => {
        dispatch(setNodeData({ [component.id]: newNodeData[component.id] }));
        closeData['nodeLinks'].push(component.id);
        closeData['closeActions']['addNodes'].push(component);
      });
    }
    setDisableSubmit(false);
    setAllAddComponents([]);
    closeGritComponent(closeData, modifiedTemplatizations, addFormSubmitAction);
  };

  useEffect(() => {
    if (allAddComponents.length > 0) {
      setDisableSubmit(modifiedData['links']['localAccountSignIn'] && modifiedData['username'] == '');
      setUnsavedChanges(false);
    } else {
      const _res: boolean = checkIfSameIgnoringSubFlows(['formSubmitAction']);
      setDisableSubmit(_res ||
        (modifiedData['links']['localAccountSignIn'] && modifiedData['username'] == '') ||
        selectedLinks(modifiedData['links']).length === 0 ||
        (!sessionFieldsAreValid(modifiedData))
      );
      setUnsavedChanges(_res);
    }
    if (!modifiedData.hasOwnProperty('nodeLinks')) {
      setModifiedData({ ...modifiedData, nodeLinks: [] });
    }
  }, [modifiedData, allAddComponents]);

  return (
    <div>
      <div className={classes.flexRow}>
        <TemplatizedFieldComponent
          changeHandler={(e: TemplatizedValue) => {
            setModifiedData({ ...modifiedData, contentDefinition: { ...e } });
          }}
          setModifiedTemplatizations={setModifiedTemplatizations}
          modifiedTemplatizations={modifiedTemplatizations}
          data={{
            label: 'Content Definition',
            fieldPath: 'contentDefinition',
            style: { margin: 1, width: 600 },
            value: getTemplatizedValue(modifiedData['contentDefinition']),
            variant: 'text'
          }}
        />
      </div>
      {modifiedData['links']['localAccountSignIn'] && (
        <div className={classes.flexRow}>
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<any>) => {
              setModifiedData({ ...modifiedData, ['usernameType']: e.target.value });
            }}
            data={{
              value: modifiedData.usernameType,
              label: configData.usernameType.displayName,
              options: configData.usernameType.values.reduce(
                (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                [],
              ),
              style: { margin: 1, width: 300 },
              required: true,
            }}
          />
          <SelectComponent
            changeHandler={(e: SelectChangeEvent<any>) => {
              setModifiedData({ ...modifiedData, ['username']: e.target.value });
            }}
            data={{
              value: modifiedData.username,
              label: configData.username.displayName,
              options:
                configData.username.values === 'allClaims'
                  ? Object.keys(allClaims).reduce(
                      (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
                      [],
                    )
                  : [],
              style: { margin: 1, width: 300 },
              required: true,
            }}
          />
        </div>
      )}

      <div className={classes.flexRow}>
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<any>) => {
            setModifiedData({ ...modifiedData, ['keepMeSignedIn']: e.target.value });
          }}
          data={{
            value: modifiedData.keepMeSignedIn,
            label: configData.keepMeSignedIn.displayName,
            options: configData.keepMeSignedIn.values.reduce(
              (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
              [],
            ),
            style: { margin: 1, width: 300 },
            required: true,
          }}
        />
        <SelectComponent
          changeHandler={(e: SelectChangeEvent<any>) => {
            setModifiedData({ ...modifiedData, ['showPasswordTextbox']: e.target.value });
          }}
          data={{
            value: modifiedData.showPasswordTextbox,
            label: configData.showPasswordTextbox.displayName,
            options: configData.showPasswordTextbox.values.reduce(
              (acc: OptionProps[], curVal: string) => acc.concat({ label: curVal, value: curVal }),
              [],
            ),
            style: { margin: 1, width: 300 },
            required: true,
          }}
        />
      </div>

      <FormControl required sx={{ m: 1, minWidth: 400 }}>
        <FormControl component="fieldset" sx={{ m: 1 }}>
          <FormLabel component="legend">links</FormLabel>
          <FormGroup row>
            {Object.keys(configData.links).map((v, index) => {
              // @ts-ignore
              const displayName = configData.links[v].displayName;
              return v !== 'socialProviders' ? (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      checked={modifiedData.links[v]}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setModifiedData({
                          ...modifiedData,
                          links: { ...modifiedData['links'], [v]: !modifiedData.links[v] },
                        });
                      }}
                      name={displayName}
                    />
                  }
                  label={displayName}
                />
              ) : null;
            })}
          </FormGroup>
        </FormControl>
        {settings.enableCustomSignInLinks && (
          <FormControl component="fieldset" sx={{ m: 1 }}>
            <div className={cn(classes.flexRow)}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {(modifiedData['nodeLinks'] || []).map((value: any) => {
                  return (
                    <Chip
                      className={classes1.addedComponent}
                      onDelete={() => {
                        setModifiedData({
                          ...modifiedData,
                          nodeLinks: modifiedData['nodeLinks'].filter((link: string) => link !== value),
                        });
                      }}
                      deleteIcon={<ClearIcon style={{ color: '#FFFFFF' }} />}
                      key={value}
                      label={flowchartNodesEdges['nodes'].find((node: any) => node.id === value)['data']['label']}
                    />
                  );
                })}
                {(allAddComponents || []).map((value: any) => {
                  return (
                    <Chip
                      className={classes1.addedComponent}
                      onDelete={() => {
                        setAllAddComponents(allAddComponents.filter((comp: any) => comp.id !== value.id));
                      }}
                      deleteIcon={<ClearIcon style={{ color: '#FFFFFF' }} />}
                      key={value.id}
                      label={value['data']['label']}
                    />
                  );
                })}
              </Box>
            </div>
            <div className={cn(classes.flexRow)}>
              <div className={cn(classes.flexRow, classes.alignBase)}>
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<any>) => {
                    setAddComponent(e.target.value);
                  }}
                  data={{
                    value: addComponent,
                    label: 'Add a Component',
                    options: components.reduce(
                      (acc: any, curVal: any) =>
                        acc.concat({
                          label: curVal.displayName,
                          value: curVal.componentType,
                          disabled: curVal.disabled,
                        }),
                      [],
                    ),
                    style: { margin: 1, width: 300 },
                    required: true,
                  }}
                />
                <TextComponent
                  changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    setAddComponentName(e.target.value);
                  }}
                  data={{
                    value: addComponentName,
                    label: 'Label',
                    style: { margin: 1, width: 500 },
                    required: true,
                  }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  onClick={() => {
                    let newNode: any;
                    // @ts-ignore
                    const componentConfigData: any = jsonComponentsConfig[addComponent];
                    let initComponent: any = getInitComponent(addComponent);
                    initComponent.flowchart = currentFlowChartData.id;
                    setNewNodeData({
                      ...newNodeData,
                      [initComponent['id']]: {
                        ...initComponent,
                        parentNodeId: componentData?.id,
                        linkId: true,
                        linkType: addComponent,
                        flowchart: modifiedData['flowchart']
                      },
                    });

                    newNode = {
                      id: initComponent['id'],
                      parentNodeId: componentData?.id,
                      type: componentConfigData['nodeType'],
                      componentType: addComponent,
                      linkId: true,
                      linkType: addComponent,
                      position: {},
                      data: { label: addComponentName },
                    };
                    setAllAddComponents([...allAddComponents, newNode]);
                    setAddComponent('');
                    setAddComponentName('');
                  }}
                  disabled={addComponent === '' || addComponentName.trim() === ''}
                >
                  Add Component
                </Button>
              </div>
            </div>
          </FormControl>
        )}
        <FormControl component="fieldset" sx={{ m: 1 }}>
          <FormLabel component="legend">Social and Federated providers</FormLabel>
          <FormGroup row>
            {Object.keys(configData.links.socialProviders).map((v: any, _index: number) => {
              // @ts-ignore
              const displayName = configData.links.socialProviders[v].displayName;
              return (
                <FormControlLabel
                  key={_index}
                  control={
                    <Checkbox
                      checked={modifiedData.links.socialProviders[v]}
                      // @ts-ignore
                      disabled={!configData.links.socialProviders[v].enabled}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setModifiedData({
                          ...modifiedData,
                          links: {
                            ...modifiedData['links'],
                            socialProviders: {
                              ...modifiedData['links']['socialProviders'],
                              [v]: !modifiedData.links.socialProviders[v],
                            },
                          },
                        });
                      }}
                      name={displayName}
                    />
                  }
                  label={displayName}
                />
              );
            })}
          </FormGroup>
        </FormControl>

        {configData.sessionManagement && (
          <SessionManagement
            modifiedData={modifiedData}
            changeHandler={(data: any) => setModifiedData(data)}
            sessionTypes={configData.sessionTypes}
          />
        )}

        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          onClick={() => {
            closeComponent(modifiedData);
          }}
          disabled={disableSubmit}
        >
          Save
        </Button>
        {modifiedData.hasOwnProperty('formSubmitAction') && modifiedData['formSubmitAction']['id'] === '' && (
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={() => closeComponent(modifiedData, true)}
          >
            Add Form Submit Action
          </Button>
        )}

        {modifiedData.hasOwnProperty('formSubmitAction') && modifiedData['formSubmitAction']['id'] !== '' && (
          <div className={classes.flexRow}>
            <div
              className={classes.pointer}
              onClick={() => {
                if (!disableSubmit) {
                  closeComponent(modifiedData, false);
                  window.alert('Saving information in the popup. Click again on the link to navigate.');
                } else {
                  openSubmitActionFC(modifiedData);
                }
              }}
            >
              {modifiedData['formSubmitAction']['displayName']} &nbsp;&nbsp;&nbsp;
              <a href="#">Click here to edit Submit Action.</a>
            </div>
            <div>
              <DeleteIcon
                onClick={() => {
                  window.confirm('Are you sure you want to delete the form submit action ? This cannot be undone.') &&
                    onDeleteSubFlow(modifiedData['formSubmitAction']['id'], 'formSubmitAction');
                }}
                className={classes.icon}
                color="error"
              />
            </div>
          </div>
        )}
      </FormControl>
    </div>
  );
};
// export default withAITracking(reactPlugin, GenerateSignInUI);
export default GenerateSignInUI;
